"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const keautils_1 = require("keautils");
const logic_1 = require("./logic");
const row_1 = require("./row");
const table_1 = require("../table");
const text_1 = require("../grid2Base/simpleGrid/text");
class TreeComponent extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.collapsedPathSelector = (props) => props.state.collapsed;
        this.treeSelector = (props) => props.value;
        this.treeRowsSelector = keautils_1.createSelector(this.treeSelector, this.collapsedPathSelector, (tree, collapsedPath) => logic_1.getTreeRows([], tree, collapsedPath));
        this.stateSelector = (props) => props.state;
        this.onStateChangeSelector = (props) => props.onStateChange;
        this.handleOnCollapsedChageSelector = keautils_1.createSelector(this.onStateChangeSelector, this.stateSelector, (onChange, value) => (collapsed) => onChange(Object.assign({}, value, { collapsed })));
        this.handleOnItemCollapsedChangeSelector = keautils_1.createSelector(this.handleOnCollapsedChageSelector, this.collapsedPathSelector, (onChange, collapsed) => (path, value) => onChange(logic_1.handleOnCollapsedChange(path, value, collapsed)));
        this.treeRowPropsSelector = keautils_1.createSelector(this.treeRowsSelector, this.handleOnItemCollapsedChangeSelector, (rows, onCollapsed) => rows.map(x => ({
            key: x.path.join("/"),
            path: x.path,
            level: x.path.length,
            collapsed: x.collapsed,
            onCollapsedChange: (value) => onCollapsed(x.path, value),
            value: x.value
        })));
        this.rowRendererSelector = (props) => props.valueRenderer || text_1.cellToText;
        this.treeRowComponentsSelector = keautils_1.createSelector(this.treeRowPropsSelector, this.rowRendererSelector, (rows, renderer) => rows.map(row => React.createElement(row_1.TreeRowComponent, Object.assign({}, row), renderer(row.value, row.path))));
    }
    render() {
        const rows = this.treeRowComponentsSelector(this.props);
        return React.createElement(table_1.Table, { items: rows });
    }
}
exports.TreeComponent = TreeComponent;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/treeview/component.js
// module id = 2259
// module chunks = 0